import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ServiceResponse } from 'src/app/models/service-response';
import { ProfilService } from 'src/app/rest_services/profil.service';
import { RoleService } from 'src/app/rest_services/role.service';

@Component({
  selector: 'app-profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.css']
})
export class ProfilesComponent implements OnInit, OnDestroy {

  profilesLoading = true;
  profilesSubscription!: Subscription;
  profiles: any[]= [];
  profile: any;
  editProfilForm!:FormGroup;
  updateLoading:boolean = false;
  refRoles:any[]=[]
  htmlYouWantToAdd:any="";
  formModified: boolean = false;

  roles:any[] =[];
  initialRoles: any[]=[];
  constructor(
    private formBuilder: FormBuilder,
    private profileService: ProfilService,
    private roleService: RoleService) { }

    ngOnInit(): void {
      var glob = this;
      
      $(document).ready(function() {
        // Use event delegation to listen for changes on dynamically created elements with the class "role-select"
        $(document).on('change', '[id^="role-"]', function() {
          if(glob.selectedProfil.roles == undefined) glob.selectedProfil.roles =[];
          var value = $(this).val();
          var elt = glob.selectedProfil.roles?.find((el:any) => el.uuid == value);
          var uuid = $("option:selected", this).attr("ud");
          var role = {
            description: $("option:selected", this).text(),
            uuid: uuid
          };
          
          let index = -1;
          if (elt !== undefined) {
            index = glob.selectedProfil.roles?.findIndex((d :any) => d.description == elt.description);
          }
          if (index < 0 && value !== "") {
            var alreadySelected = glob.selectedProfil.roles?.some((item: any) => item.uuid === uuid);
            if (!alreadySelected) {
              const existingRole = glob.selectedProfil.roles?.find((item: any) =>
                glob.compareStringsIgnoringAccents(item.description.toString(), role.description.toString())
              );
              if (!existingRole) {
                // glob.selectedProfil.roles?.push(role);
                var insertIndex = 0;
                while (insertIndex < glob.selectedProfil.roles?.length && glob.selectedProfil.roles?.[insertIndex].description < role.description) {
                  insertIndex++;
                }
                // Insert the role at the correct index
                glob.selectedProfil.roles?.splice(insertIndex, 0, role);
                glob.checkForRoleChanges();
                setTimeout(function() {
                  // Find the closest "role-select" element and reset its value
                  $(this).val("");
                }, 500);
              }
            } else {
              console.log("Role already selected!");
            }
          }
        });
      });
    
      this.getCompanyProfiles();
      this.getCompanyRoles();
      this.initForm();
    }
    
    initForm(){
      this.editProfilForm = this.formBuilder.group({
        'label': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30), this.noSpecialCharsValidator()]],
        'description': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(1000), this.noSpecialCharsValidator()]],
        'role': ['']
      });
    }
    noSpecialCharsValidator(): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } | null => {
        const forbidden = /[@#$%^&*+{}[\]<>?~\\]/.test(control.value);
        return forbidden ? { 'noSpecialChars': true } : null;
      };
    }
  compareStringsIgnoringAccents(str1: string, str2: string): boolean {
    if (!str1 || !str2) {return false;}
    const normalizedStr1 = str1.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalizedStr2 = str2.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalizedStr1.toLowerCase() === normalizedStr2.toLowerCase();
  }

  getCompanyProfiles() {
    this.profilesSubscription = this.profileService.getCompanyProfiles().subscribe(
      (resp:ServiceResponse) => {
        if (resp.code == "04af68f47a2a3038ddc63abc533719d1") {
          this.profiles = resp.profiles;
        }
        this.profilesLoading = false;
      },
      (err:any) => {
        console.log(err);
        this.profilesLoading = false;
        
      }
    );
  }

  getProfile(profile:any) {
    this.profile = profile;    
    this.getProfileRoles(this.profile);
  }
  rolesLoading : boolean = true;
  getProfileRoles(item : any){
    this.profile = item;
    this.selectedProfil = item;
    this.rolesLoading = true;
    this.rolesSubscription = this.roleService.getProfileRoles(item.uuid).subscribe(
      (resp: any) => {
        if(resp.code == "bf025c4dcce776832c0d50903044d7f5") {
          this.profile.roles=[];
          this.profile.roles = resp.profileRoles;
          this.initialRoles = [...resp.profileRoles];
          this.selectedProfil.roles = resp.profileRoles;
          this.rolesLoading = false;
          this.roles=this.selectedProfil.roles;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getNameProfile(name:any) {
    switch (name) {
      case "PROFILE_ADMIN":
        return "Directeur Commercial";
      case "PROFILE_COMMERCIAL":
        return "Commerciaux";
      case "PROFILE_COMMERCIAL_ASSISTANT":
        return "Assistante Commerciale";  
      default:
        return name.replaceAll("_", " ");
    }
  }

  getProfileIcons(name:string) {
    switch (name) {
      case "PROFILE_ADMIN":
        return "Directeur Commercial";
      case "PROFILE_COMMERCIAL":
        return "Commerciaux";
      case "PROFILE_COMMERCIAL_ASSISTANT":
        return "Assistante Commerciale";  
      default:
        return name;
    }
  }

  rolesSubscription!: Subscription;
  getCompanyRoles(){
    this.rolesSubscription = this.roleService.getCompanyRoles().subscribe(
      (resp: ServiceResponse) => {
        if(resp.code == "bf025c4dcce776832c0d50903044d7f5") {
          this.refRoles = resp.roles;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  initialFormValues: { [key: string]: any } = {};

  isFormUnchanged(controlName: string): boolean {
    const currentFormValue = this.editProfilForm.get(controlName)?.value;
    const initialFormValue = this.initialFormValues[controlName];
    return currentFormValue === initialFormValue;
  }
  checkForRoleChanges() {
    if (this.roles.length != this.initialRoles.length) {
      this.formModified = true;
      return;
    }
  for (const currentRole of this.roles) {
    const roleExists = this.initialRoles.some(initialRole => initialRole.description === currentRole.description);
    if (!roleExists) {
      this.formModified = true;
      return;
    }
  }
    this.formModified = false;
  }

  selectedProfil:any
  selectProfil(item :any){
    this.getProfileRoles(item)
    this.selectedProfil=item;
    if (this.selectedProfil.name == 'PROFILE_ADMIN' || this.selectedProfil.name == 'PROFILE_COMMERCIAL' || this.selectedProfil.name == 'PROFILE_COMMERCIAL_ASSISTANT' ) {
      this.editProfilForm.get('label')?.disable();
    } else {
      this.editProfilForm.get('label')?.enable();
    }
    this.editProfilForm.patchValue({
      'label': this.selectedProfil.name.replaceAll("_", " "),
      'description': this.selectedProfil.description,
    });
    this.initialFormValues['label'] = this.editProfilForm.get('label')?.value;
    this.initialFormValues['description'] = this.editProfilForm.get('description')?.value;
    this.formModified= false;
    this.editProfilForm.get('label')?.valueChanges.subscribe(() => {
      this.formModified = !this.isFormUnchanged('label');
    });

    this.editProfilForm.get('description')?.valueChanges.subscribe(() => {
      this.formModified = !this.isFormUnchanged('description');
    }); 
  }
  removeRole(Role: any) {
    const RoleIndex = this.roles.findIndex((c: any) => c.uuid === Role.uuid);
    if (RoleIndex !== -1) {
      this.roles.splice(RoleIndex, 1)[0];
      this.checkForRoleChanges();
    }
  }
  addError:string='';
  updateProfil(){
    // $("html, body").animate({ scrollTop: 0 });
    this.updateLoading = true;
    if (this.editProfilForm.valid) {
      const profilData = this.editProfilForm.value;
      profilData.uuid = this.selectedProfil.uuid;
      profilData.label = this.editProfilForm.get('label')?.value;
      profilData.description = this.editProfilForm.get('description')?.value
      profilData.roles= this.roles;
      this.profileService.updateProfile(profilData);
      this.profileService.editProfilSubject.subscribe((response) => {
        this.updateLoading = false;
        (<any>$('#editProfilModal')).modal('hide');
        if (response.code == "78fbb3ba505b0e21c56909aa8f18a4ba") {
          this.editProfilForm.reset();
          // this.selectedProfil.roles = this.roles;
          this.roles=[];
          $("#profil_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_updated").hide();
          }, 2000);
        } else if(response.code == "f992d63504b5d334c75e777c0bafc848")  {
          this.addError ="profil n'existe pas!!"; 
          $("#profil_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_updated").hide();
          }, 3000);
        } else if (response.code == "30973e20a8058d0cb3f25633bb6f275e" || response.code == "40606e42c14a45c2bd293a5722f1a262") {
          this.addError =". Données invalides pour la modification du profil"; 
          $("#profil_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_updated").hide();
          }, 3000);
        }else if (response.code == "b4c3df6d19510ad5059729fb2bfe5134") {
          this.addError =". Vous n'avez pas le droit !!"; 
          $("#profil_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_updated").hide();
          }, 3000);
        }
      },
      (error) => {
        console.log('profil creation error:', error);
        this.addError =". profil non modifié"; 
          $("#profil_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_updated").hide();
          }, 3000);
      });
    } else {
     this.updateLoading = false;
    }
  }
  historyLoading:boolean = false;
  history:any[]=[];
  forWhat:any='/creationHistory'

  getHistory() {
    this.historyLoading=true;
    this.profilesSubscription = this.profileService.getHistory(this.selectedProfil.uuid, this.forWhat).subscribe(
      (resp:any) => {
        if (resp.code == "70105b5c5ff9e3f8fafdf2ea024a3c95") {
          this.history = resp.history;
          setTimeout(()=>{
            (<any>$("#alter_paginations")).DataTable( {
              "pagingType": "full_numbers",
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              "order": [
                [0, "desc"]
              ],
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
        }
        this.historyLoading=false;
      },
      (err:any) => {
        console.log(err);
        this.historyLoading=false;
      }
    );
  }
  ngOnDestroy(): void {
   this.profilesSubscription?.unsubscribe();
  }

}
